const ENVIRONMENTS = {
  DEVELOPMENT: 'development',
  STAGING: 'staging',
  PRODUCTION: 'production',
};

const DEFAULT_ENVIRONMENT = ENVIRONMENTS.DEVELOPMENT;

export { ENVIRONMENTS, DEFAULT_ENVIRONMENT };
export default ENVIRONMENTS;
